import urlHelper, { UrlFacets } from '@/core/urlHelper.service';
import { FacetsViewModel } from '@/types/apiServerContract';

function createUrlFacets(existingFacets: FacetsViewModel | null = null): UrlFacets {
    const facets: UrlFacets = { ...urlHelper.getFacets() };

    // If we have a previous result, preserve the position of the selected facets
    if (existingFacets) {
        const keys = Object.keys(facets);
        for (const key of keys) {
            let facetId = key;
            if (key.startsWith('from_')) {
                facetId = key.slice('from_'.length);
            }

            const facet = existingFacets.facets.find(x => x.facetId === facetId);
            if (facet) {
                const newKey = key + ':' + facet.position;
                delete Object.assign(facets, { [newKey]: facets[key] })[key];
            }
        }
    }

    return facets;
}
export default {
    createUrlFacets
};
